import { queryOptions } from "@tanstack/react-query";

import { type UserResponse, publicApiClient } from "@/lib/api/client";
import { getApiErrorMessage } from "@/lib/api/errors";

import { authKeys } from "./keys";

async function fetchCurrentUser(): Promise<UserResponse | null> {
  const { data, error, response } = await publicApiClient.GET("/api/v1/me");

  if (response.status === 401) {
    return null;
  }

  if (error || !data) {
    throw new Error(getApiErrorMessage(error, "Failed to load profile."));
  }

  return data;
}

/**
 * Query options for the current session user (`GET /api/v1/me`).
 *
 * Retry and staleTime come from the shared query-client defaults
 * (see `createAppQueryClient`); a `401` resolves to `null` rather than erroring.
 */
export function meQueryOptions() {
  return queryOptions({
    queryKey: authKeys.me,
    queryFn: fetchCurrentUser,
  });
}
